import type { ReactNode } from 'react';
import { create } from 'zustand';
import { Button } from './button';

export interface ModalSpec {
  title: string;
  body: ReactNode;
  footer?: ReactNode;
  large?: boolean;
  onClose?: () => void;
}
interface ModalState {
  modal: ModalSpec | null;
  open: (spec: ModalSpec) => void;
  close: () => void;
}

export const useModalStore = create<ModalState>((set, get) => ({
  modal: null,
  open: (modal) => set({ modal }),
  close: () => {
    get().modal?.onClose?.();
    set({ modal: null });
  },
}));

export const modal = {
  open: (spec: ModalSpec) => useModalStore.getState().open(spec),
  close: () => useModalStore.getState().close(),
};

export function confirmModal(opts: { title: string; message: string; confirmLabel?: string; danger?: boolean }): Promise<boolean> {
  return new Promise((resolve) => {
    let settled = false;
    const finish = (v: boolean) => {
      if (settled) return;
      settled = true;
      resolve(v);
      useModalStore.setState({ modal: null });
    };
    modal.open({
      title: opts.title,
      body: <p>{opts.message}</p>,
      onClose: () => finish(false),
      footer: (
        <>
          <Button onClick={() => finish(false)}>Cancel</Button>
          <Button variant={opts.danger ? 'danger' : 'primary'} onClick={() => finish(true)}>{opts.confirmLabel ?? 'Confirm'}</Button>
        </>
      ),
    });
  });
}
